import { isObject } from "./is-object";

type FlattenedObject = Record<string, string>;

const SEPARATOR = ".";

export function flattenObject(
  obj: Record<string, unknown>,
  parentKey = "",
): FlattenedObject {
  const flattened: FlattenedObject = {};

  for (const key in obj) {
    const newKey = parentKey ? `${parentKey}${SEPARATOR}${key}` : key;
    const value = obj[key];

    if (isObject(value)) {
      Object.assign(
        flattened,
        flattenObject(value as Record<string, unknown>, newKey),
      );
    } else if (typeof value === "number") {
      flattened[newKey] = String(value);
    } else if (typeof value === "string") {
      flattened[newKey] = value;
    }
  }

  return flattened;
}
